module.exports = __webpack_public_path__ + "img/antes_despues_261.dfc3e914.png";